var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "860bfe30e40d8d7e59bb416c058761f4536b41f3"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["butternutbox-frontend@butternut"] = {
  id: "860bfe30e40d8d7e59bb416c058761f4536b41f3"
};